<template>
    <div>
        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3  text-white">Past Events</h1>
                                <p class="lead  text-white">From our first glow jars event to extracting strawberry DNA in the lab, 
                                    we loved seeing the excited and bright smiles on the faces of our members.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        <section class="section section-lg pt-lg-0 mt--200">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-check-bold" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">Fruit Ninja: DNA Extractions</h6>
                                    <h7 class="text-primary text-uppercase">19.04.03</h7>
                                    <p class="description mt-3">Hey Seedlings! Interested in DNA structures? Want to become a forensics scientist? 
                                        Join Women in STEM on WEDNESDAY, APRIL 3 in room 129 to extract fruit DNA from STRAWBERRIES!! 🍓 
                                        It's going to be BERRY fun!! See you there! 💗</p>
                                    <img src="img/events/Fruit Ninja DNA Extractions.jpg" style="width: 275px;" alt="Fruit Ninja Poster">
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-check-bold" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">STEM Out Speaker Series: Michelle Chen</h6>
                                    <h7 class="text-primary text-uppercase">19.03.01</h7>
                                    <p class="description mt-3">Are you interested in studying at Ivey Business School, interning at Microsoft, learning about tech? 
                                        Join WIS in the cafeteria on Friday, March 1 for our STEM Out Speaker Series: Michelle Chen! 
                                        Michelle Chen is currently pursuing a dual degree in Computer Science and an HBA from Ivey Business School. 
                                        Alongside her academic achievements, Michelle is also the president of the Women in Technology Society at the University of Western Ontario. 
                                        In 2018, she worked as a PM intern at Microsoft and helped with the development of AI, Security, Hololens AR, and UX research. 
                                        This summer, Michelle will be joining Cloudflare as a PM on their Product Strategy team.</p>
                                    <img src="img/events/STEM Out Speaker Series Michelle Chen.png" style="width: 275px;" alt="SOSS Michelle Chen Poster">
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-check-bold" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">Let's Get This (ginger)Bread</h6>
                                    <h7 class="text-primary text-uppercase">18.12.12</h7>
                                    <p class="description mt-3">If WIS was the Grinch, we wouldn't steal Christmas. We'd steal you. 😉 
                                        Happy December, Seedlings!! It's the perfect time to get festive and destress, 
                                        so call up all of your friends to come BUILD GINGERBREAD HOUSES in the caf on 
                                        Wednesday, December 12 after school! However, WIS meetings wouldn't be WIS meetings without 
                                        having a little STEM kick, so may the strongest, most creative gingerbread house win! (There will be an earthquake test! 😨)
                                        HOPE TO SEE YOU THERE! </p>
                                    <img src="img/events/Let's Get This Bread.png" style="width: 275px;" alt="LGTB Poster">
                                </card>
                            </div>
                             <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-check-bold" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">Leaning Tower of Pasta Challenge</h6>
                                    <h7 class="text-primary text-uppercase">18.11.14</h7>
                                    <p class="description mt-3">Up for a challenge? WIS and Bayview Robotics present the Leaning Tower of Pasta! 
                                        Come join us on Wednesday, November 14 after school in G15! Each team will be provided with 30 sticks of spaghetti, 
                                        1 meter of tape, 1 meter of string, and 1 marshmallow. Be the fastest team in building the tallest free-standing structure! 
                                        Prizes will be won!</p>
                                    <img src="img/events/Leaning Tower of Pasta 2.png" style="width: 275px;" alt="LToP Poster">
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-check-bold" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">Ready, Set, Glow</h6>
                                    <h7 class="text-primary text-uppercase">18.10.31</h7>
                                    <p class="description mt-3">Come by to learn about bioluminescence and 
                                        make your own GLOW JARS (oooo spooky!!) That's right, stars aren't the only things that shine at night 🌟 
                                        (All materials and even some Halloween treats will be provided!)</p>
                                    <img src="img/events/WIS Glow Jar Meeting.jpg" style="width: 275px;" alt="Glow Jar Poster">
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-check-bold" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">Intro to Java 101</h6>
                                    <h7 class="text-primary text-uppercase">18.10.10</h7>
                                    <p class="description mt-3">Bayview WIS will be having their first meeting on Wednesday, October 10! We will be starting with the theme of TECHNOLOGY!
                                        If you are interested in learning the basics of coding in Java, feel free to drop in at 3:30 PM at G15. We will be covering the basic syntax 
                                        of Java and writing a few practice codes on Eclipse IDE!</p>
                                    <img src="img/events/BWiS Intro to Java.png" style="width: 275px;" alt="Intro to Java Poster">
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
  name: "home",
  components: {}
};
</script>
